export const payrateSettingsSelector = (state) =>
  state.payrateSettingReducer?.settings;

export const payrateSettingsLoadingSelector = (state) =>
  state.payrateSettingReducer?.loading || false;
